import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
    {
        path: "/wxPay",
        name: "wxPay",
        component: () =>
            import ("../view/wxpay/WxPay.vue"),
        meta: {
            name: '云掌柜-收银台'
        },
    },
    {
        path: "/orderSearch",
        name: "orderSearch",
        component: () =>
            import ("../view/wxpay/OrderSearch.vue"),
        meta: {
            name: '查询订单'
        },
    },
    {
        path: "/paySuccess",
        name: "paySuccess",
        component: () =>
            import ("../view/wxpay/PaySuccess.vue"),
        meta: {
            name: '查询订单'
        },
    },
    {
        path: "/voucher",
        name: "voucher",
        component: () =>
            import ("../view/mitu/Voucher.vue"),
        meta: {
            name: '米途预售'
        },
    },
    {
        path: "/",
        name: "error",
        component: () =>
            import ("../view/Error.vue"),
        meta: {
            name: ''
        },
    },
]

const router = new VueRouter({
    routes,
    mode: 'history'
})

//const blackList = ['/list'] // 需要登录的页面

router.beforeEach((to, from, next) => {
    document.getElementsByTagName("title")[0].innerText = to.meta.name;
    if (sessionStorage.token) {
        next();
    } else {
       next();
    }
})
export default router
